import axios from 'axios';

export default function postCorrectionRequest(correctionRequest, config) {
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
        'x-location-id': localStorage.getItem('locationId')
    };

    const url = config.postCorrectionRequest;
    return dispatch => dispatch({
        type: 'POST_CORRECTION_REQUEST',
        payload: axios({ method: 'post', url, headers, data: { correctionRequest } })
    });
}


// WEBPACK FOOTER //
// ./src/actions/postCorrectionRequest.js